import { MessageCircle } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { waLink } from "@/lib/contact";

const PORTRAIT_IMG = "/keshav.jpg";

const credentials = [
  "BPTh — Bachelor of Physiotherapy",
  "Certified Personal Trainer",
  "Strength & Conditioning Coach",
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-36 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <SectionLabel>Meet Your Practitioner</SectionLabel>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="font-display font-light text-[#111111] text-5xl sm:text-6xl md:text-7xl leading-[1.0] tracking-tight mt-8 max-w-4xl">
            "Movement is the
            <span className="italic text-[#8DA37F]"> best medicine.</span>"
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-14 lg:gap-10 items-center mt-16 md:mt-24">
          <div className="lg:col-span-5 relative">
            <Reveal>
              <div className="relative">
                <div className="absolute -bottom-5 -left-5 w-full h-full bg-[#8DA37F]/30" />
                <div className="relative overflow-hidden aspect-[4/5]">
                  <img
                    src={PORTRAIT_IMG}
                    alt="Keshav Padwal with a patient"
                    className="w-full h-full object-cover"
                    data-testid="about-image"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/30 via-transparent to-transparent" />
                </div>
                <div className="absolute -right-4 md:-right-8 bottom-8 bg-[#111111] text-[#F5F0E8] px-6 py-5">
                  <p className="font-display text-4xl leading-none">
                    200<span className="text-[#8DA37F]">+</span>
                  </p>
                  <p className="text-xs tracking-[0.15em] uppercase mt-2 text-[#F5F0E8]/60">
                    Patients pain-free &amp; stronger
                  </p>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            <Reveal delay={0.15}>
              <p className="text-xs tracking-[0.25em] uppercase font-medium text-[#6b7f5e]">
                Keshav Padwal
              </p>
              <h3 className="font-display font-light text-[#111111] text-3xl sm:text-4xl md:text-5xl leading-tight tracking-tight mt-4">
                A dedicated physiotherapist striving each day to make the phrase
                <span className="italic text-[#8DA37F]"> "movement is medicine" </span>
                true in everyone's life.
              </h3>
            </Reveal>

            <Reveal delay={0.22}>
              <p className="mt-7 max-w-xl text-base md:text-lg leading-relaxed text-[#111111]/70">
                Every plan starts with how your body actually moves — not a
                template. Whether you're coming back from injury or chasing a new
                personal best, the goal is the same: a body you can trust.
              </p>
            </Reveal>

            <Reveal delay={0.28}>
              <ul className="mt-9 space-y-0 border-t border-[#E5E0D8]" data-testid="about-credentials">
                {credentials.map((c) => (
                  <li
                    key={c}
                    className="flex items-center justify-between gap-4 border-b border-[#E5E0D8] py-4 group"
                  >
                    <span className="text-base md:text-lg text-[#111111]/85 group-hover:text-[#111111] transition-colors duration-300">
                      {c}
                    </span>
                    <span className="h-1.5 w-1.5 rotate-45 bg-[#8DA37F] shrink-0" />
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={0.34}>
              <a
                href={waLink("Hi Keshav, I found Physiora online and would like to talk about my concern.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-whatsapp-btn"
                className="mt-10 inline-flex items-center gap-3 bg-[#111111] text-[#F5F0E8] text-xs tracking-[0.15em] uppercase font-medium px-8 py-4 rounded-full hover:bg-[#8DA37F] hover:text-[#111111] hover:-translate-y-0.5 transition-all duration-300"
              >
                <MessageCircle className="h-4 w-4" />
                Say hello on WhatsApp
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
